export default __webpack_public_path__ + "static/filipk-06d9db6bedd9fb9132612598740a39d5.png";